import { createFileRoute } from "@tanstack/react-router";
import PositiveImageryArchiveSessionOverview from "@/components/Exercises/Positive-Imagery/archivePage/PositiveImageryArchiveSessionOverview";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/positive-imagery/session"
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <PositiveImageryArchiveSessionOverview />;
}

